import {
  jb_upload_css_default
} from "./chunk.ZKJUTDPJ.js";
import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  FormElement
} from "./chunk.MEO2C6ZS.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  D,
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  e,
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-upload/jb-upload.ts
var JbUpload = class extends Initiable(FormElement(r)) {
  showSelectedFile() {
    this.isUploaded = true;
    this.fileName = this._uploadInputFile.files[0].name;
    [this.value] = Array.from(this._uploadInputFile.files);
    this.dispatchEvent(new CustomEvent("jb-upload:field-change", { bubbles: true, composed: true }));
  }
  _clearInput() {
    this.value = void 0;
    this.fileName = void 0;
  }
  _openFileDialog() {
    this._uploadInputFile.click();
  }
  render() {
    const classes = {
      error: this.showError || !!this.errorText,
      uploaded: !!this.isUploaded,
      disabled: !!this.disabled
    };
    return ke`
      <div class="${Rt(classes)}">
        ${this.label ? ke`<p class="label">${this.label}${this.requiredText ? "*" : D}</p>` : D}
        ${this.description ? ke`<p class="description">${this.description}</p>` : D}

        <input
          ?disabled=${this.disabled}
          ?required=${!!this.requiredText}
          @change=${this.showSelectedFile}
          name=${this.name}
          type="file"
          aria-errormessage="${this.showError || this.errorText ? `${this.name}_error` : D}"
        />

        ${this.fileName ? ke`<p class="file-name">
              <span>${this.fileName}</span><jb-clear-icon @click=${this._clearInput}></jb-clear-icon>
            </p>` : D}

        <jb-button-secondary
          @jb-button:clicked=${this._openFileDialog}
          name="uploadbutton"
          >${this.buttonText}</jb-button-secondary
        >
        <div
          aria-live="polite"
          id="${this.name}_error"
        >
          ${this.showError || this.errorText ? ke`
                <p class="error-msg">
                  ${this.showError ? ke`<span>${this.requiredText}</span>` : D}
                  ${this.errorText ? ke`<span>${this.errorText}</span>` : D}
                </p>
              ` : D}
        </div>
      </div>
    `;
  }
};
JbUpload.styles = jb_upload_css_default;
__decorateClass([
  n()
], JbUpload.prototype, "buttonText", 2);
__decorateClass([
  n()
], JbUpload.prototype, "description", 2);
__decorateClass([
  n()
], JbUpload.prototype, "fileName", 2);
__decorateClass([
  n({ type: Boolean })
], JbUpload.prototype, "isUploaded", 2);
__decorateClass([
  n()
], JbUpload.prototype, "name", 2);
__decorateClass([
  e('input[type="file"]')
], JbUpload.prototype, "_uploadInputFile", 2);
JbUpload = __decorateClass([
  customElement("jb-upload")
], JbUpload);

export {
  JbUpload
};
